var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-loading',{attrs:{"active":_vm.state.isLoading}}),_c('router-view',{attrs:{"success":_vm.state.success,"result":_vm.state.result,"line":_vm.line,"error-code":_vm.state.statusCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }